import { Link } from 'react-router-dom';

export default function CTAArticle() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="rounded-2xl overflow-hidden bg-background-100 border border-background-200/60">
          <div className="aspect-[21/9] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Organized%20fashion%20product%20catalog%20spread%20with%20curated%20sneakers%20clothing%20and%20accessories%20arranged%20on%20warm%20cream%20surface%2C%20editorial%20flat%20lay%2C%20soft%20natural%20lighting%2C%20modern%20minimalist%20aesthetic%2C%20warm%20neutral%20tones%2C%20lifestyle%20product%20photography%2C%20harmonious%20balanced%20composition%20with%20central%20focus%20area&width=1200&height=600&seq=cta-article-v2-jun26&orientation=landscape"
              alt="Guia Completo Hoobuy Spreadsheet 2026"
              title="Guia Completo da Hoobuy Spreadsheet 2026"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="p-8 md:p-12 text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              Guia Completo
              <br />
              <span className="font-light italic text-foreground-500">Hoobuy Spreadsheet</span>
              <br />
              <span className="text-primary-600">2026</span>
            </h2>

            <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-lg mx-auto leading-relaxed">
              Aprenda tudo sobre como usar a melhor planilha Hoobuy. Guia completo com dicas, comparações e os melhores produtos selecionados para você.
            </p>

            <Link
              to="/artigo/hoobuy-spreadsheet-guia"
              className="mt-7 inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-white text-sm font-semibold hover:bg-foreground-800 cursor-pointer whitespace-nowrap transition-all duration-300"
            >
              Ver Guia Completo
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}